// extracted by mini-css-extract-plugin
export default {"wrap":"Uv-z","fullWidth":"Vv-z","searchPlacement":"Wv-z","items":"Xv-z","featureCss":"Yv-z","disabled":"Zv-z","imgCss":"_v-z"};